module.exports = __webpack_public_path__ + "img/oni_t.taco.d229f83.png";